let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("h7oxu"), load("5XVGB"), load("6aruy")]).then(() => parcelRequire('9VKkC'));